import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import parse, { HTMLReactParserOptions } from 'html-react-parser'
import { SubscribeForm } from 'app/sofia/components/SubscribeForm'
import { Wrapper } from '../../styled'

export const Block = ({ blockId }: { blockId: string }) => {
  const staticBlock = useCmsBlock({
    id: blockId,
    isLazy: true
  })

  if (!staticBlock.content) return null

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs } = domNode

      if (!attribs) {
        return
      }

      if (attribs.id === 'form') {
        return <SubscribeForm />
      }
    }
  }

  return (
    <Wrapper>
      {parse(staticBlock.content, options)}
    </Wrapper>
  )
}
